import React from 'react';
import { CircularProgress, makeStyles } from '@ellucian/react-design-system/core';
import { fountain100 } from '@ellucian/react-design-system/core/styles/tokens';
import { useSelector } from 'react-redux';
import { selectIsloading } from '../../redux/shared/slices/isLoadingSlice';
import PropTypes from 'prop-types';
const useStyles = makeStyles(() => ({
    overlayDisable: {
        backgroundColor: fountain100,
        position: 'fixed',
        width: '100%',
        height: '100%',
        zIndex: '1000',
        top: '0px',
        left: '0px',
        opacity: '0.5',
    },
    overlay: {
        backgroundColor: 'transparent',
        position: 'fixed',
        width: '100%',
        height: '100%',
        zIndex: '1000',
        top: '0px',
        left: '0px',
    },
    loadingIndicator: {
        position: 'fixed',
        left: '50%',
        top: '50%',
    },
}));
const PageLoadIndicator = (props) => {
    const classes = useStyles();
    const isLoading = useSelector(selectIsloading);
    if (!isLoading || props.override === true) {
        return null;
    }
    return (
        <div>
            <div className={classes.overlayDisable}>
            </div>
            <div className={classes.overlay}>
                <CircularProgress className={classes.loadingIndicator} />
            </div>
        </div>
    );
};

PageLoadIndicator.propTypes = {
    override: PropTypes.bool
};

export default PageLoadIndicator;
